
export enum LocationDetailCd {
	LOC_CON_WAY_CORPORATION = 'LocConWayCorporation',
	LOC_REFERENCE = 'LocReference'}

